import { IMap, WithId } from '@skippay/core/@types/common';
import { Country } from '@skippay/core/@types/country';

import { Banner, Config, Modal, Request } from './types';

export const FIREBASE_LOGIN_REQUESTED = 'FIREBASE_LOGIN_REQUESTED';
export const CLEAR_USER_DATA = 'CLEAR_USER_DATA';
export const SET_LAST_UPDATE_TIMESTAMP = 'SET_LAST_UPDATE_TIMESTAMP';
export const SET_BANNERS = 'SET_BANNERS';
export const SET_BANNER = 'SET_BANNER';
export const SET_REQUESTS = 'SET_REQUESTS';
export const SET_REQUEST = 'SET_REQUEST';
export const SET_CONFIG = 'SET_CONFIG';
export const SET_MODAL = 'SET_MODAL';
export const SET_MODALS = 'SET_MODALS';
export const SET_USER_COUNTRY = 'SET_USER_COUNTRY';

export type RequestFirebaseLoginAction = {
	type: typeof FIREBASE_LOGIN_REQUESTED;
};

export type ClearUserDataAction = {
	type: typeof CLEAR_USER_DATA;
};

export type SetLastUpdateTimestampAction = {
	type: typeof SET_LAST_UPDATE_TIMESTAMP;
	lastUpdateTimestamp: number;
};

export type SetBannersAction = {
	type: typeof SET_BANNERS;
	banners: IMap<Banner>;
};

export type SetBannerAction = {
	type: typeof SET_BANNER;
	banner: Banner;
};

export type SetRequestsAction = {
	type: typeof SET_REQUESTS;
	requests: IMap<WithId<Request>>;
};

export type SetRequestAction = {
	type: typeof SET_REQUEST;
	request: WithId<Request>;
};

export type SetConfigAction = {
	type: typeof SET_CONFIG;
	config: Config;
};

export type SetModalAction = {
	type: typeof SET_MODAL;
	modal: WithId<Modal>;
};

export type SetModalsAction = {
	type: typeof SET_MODALS;
	modals: IMap<WithId<Modal>>;
};

export type SetUserCountryAction = {
	type: typeof SET_USER_COUNTRY;
	country: Country;
};

export const requestFirebaseLogin = (): RequestFirebaseLoginAction => ({
	type: FIREBASE_LOGIN_REQUESTED,
});

export const clearUserData = (): ClearUserDataAction => ({
	type: CLEAR_USER_DATA,
});

export const setLastUpdateTimestamp = (
	lastUpdateTimestamp: number
): SetLastUpdateTimestampAction => ({
	type: SET_LAST_UPDATE_TIMESTAMP,
	lastUpdateTimestamp,
});

export const setBanners = (banners: SetBannersAction['banners']): SetBannersAction => ({
	type: SET_BANNERS,
	banners,
});

export const setBanner = (banner: Banner): SetBannerAction => ({
	type: SET_BANNER,
	banner,
});

export const setRequests = (requests: SetRequestsAction['requests']): SetRequestsAction => ({
	type: SET_REQUESTS,
	requests,
});

export const setRequest = (request: WithId<Request>): SetRequestAction => ({
	type: SET_REQUEST,
	request,
});

export const setConfig = (config: SetConfigAction['config']): SetConfigAction => ({
	type: SET_CONFIG,
	config,
});

export const setModal = (modal: WithId<Modal>): SetModalAction => ({
	type: SET_MODAL,
	modal,
});

export const setModals = (modals: SetModalsAction['modals']): SetModalsAction => ({
	type: SET_MODALS,
	modals,
});

export const setUserCountry = (country: Country): SetUserCountryAction => ({
	type: SET_USER_COUNTRY,
	country,
});
